import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { ILegal_Tasks } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface IProps {
    open: boolean,
    data: ILegal_Tasks,
    hideDialog: () => void,
    toast: any,
}

interface tableData {
    id?: number,
    sales?: string,
    sales_Company?: string,
    sales_Branch?: string,
    recruiter?: string,
    recruiter_Company?: string,
    recruiter_Branch?: string,
    consultant_Name?: string,
    date?: string,
}

export const LegalTaskFromDetails = (props: IProps) => {
    const [tableDataPO, setTableDataPO] = useState({ tableData: [], loading: false } as { tableData: tableData[], loading: boolean });
    const [tableDataREQ, setTableDataREQ] = useState({ tableData: [], loading: false } as { tableData: tableData[], loading: boolean });

    const dtA = useRef<any>(null);
    const dtB = useRef<any>(null);

    const loadTableData = async (sourceType: string) => {
        setTableDataPO((prev) => ({ ...prev, loading: true }));
        setTableDataREQ((prev) => ({ ...prev, loading: true }));

        try {
            const response = await Fetch("Legal_Task/getLegalTaskFromDetails", "GET", null, (`sourceType=${sourceType}` + (sourceType === "PO" ? `&poID=${props.data.pO_ID}` : `&reqID=${props.data.req_ID}`)), props.toast);

            if (response && response.ok) {
                const data = await response.json();
                setTableDataPO({ tableData: data, loading: false });
                setTableDataREQ({ tableData: data, loading: false });
            }
        } catch (error) {
            setTableDataPO((prev) => ({ ...prev, loading: false }));
            setTableDataREQ((prev) => ({ ...prev, loading: false }));
        }
    }

    useEffect(() => {
        if (props.open && props.data.sourceType !== undefined && props.data.sourceType !== null && props.data.sourceType.trim() !== "") loadTableData(props.data.sourceType || "");
    }, [props.open]);

    return (
        <Dialog visible={props.open} header={props?.data?.sourceType + " Details"} style={{ width: "90vw" }} modal onHide={() => {
            setTableDataPO({ tableData: [], loading: false });
            setTableDataREQ({ tableData: [], loading: false });
            props.hideDialog();
        }}>
            {props.open && <>
                {props?.data?.sourceType === "PO" && <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} size="small" stripedRows showGridlines responsiveLayout="scroll" value={tableDataPO.tableData} header={""} loading={tableDataPO.loading} ref={dtA}>
                    <Column header="SN" body={(rowData, { rowIndex }) => rowIndex + 1} />
                    <Column field="id" header="PO ID" />
                    <Column field="req_ID" header="Req ID" />
                    <Column field="consultant_Name" header="Consultant Name" />
                    <Column field="sales" header="Sales" />
                    <Column field="sales_Company" header="Sales Company" />
                    <Column field="sales_Branch" header="Sales Branch" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="recruiter_Company" header="Recruiter Company" />
                    <Column field="recruiter_Branch" header="Recruiter Branch" />
                    <Column field="date" header="PO Date" />
                </DataTable>}
                {props?.data?.sourceType === "REQ" && <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} size="small" stripedRows showGridlines responsiveLayout="scroll" value={tableDataREQ.tableData} header={""} loading={tableDataREQ.loading} ref={dtB}>
                    <Column header="SN" body={(rowData, { rowIndex }) => rowIndex + 1} />
                    <Column field="id" header="REQ ID" />
                    <Column field="sales" header="Sales" />
                    <Column field="sales_Company" header="Sales Company" />
                    <Column field="sales_Branch" header="Sales Branch" />
                    <Column field="date" header="Req Posted Date" />
                </DataTable>}
            </>}
        </Dialog>
    );
}